"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodes = void 0;
exports.errorCodes = {
    WALLET_SETTING_MAXIMUM_CONFIRMATION_EXCEEDED: "maxConfirmationAttemptExceeded",
    WALLET_SETTING_CONFIRMATION_CODE_INVALID: "invalidConfirmationCode",
    WALLET_SETTING_CONFIRMATION_NOT_INITITATED: "confirmationNotInitiated",
    WALLET_SETTING_ERROR_INVALID_PHONE: "invalid",
    WALLET_SETTING_PHONE_MISSING_DATA: "invalid",
    WALLET_SETTING_PHONE_EXCEEDED_MAX: "exceededMax",
    WALLET_SETTING_PHONE_INVALID_ID: "invalidId",
    WALLET_SETTING_PHONE_NOCHANGE_DETECTED: "alreadyExists",
    GRIFFIN_VALIDATION: "invalid",
};
